import { FavouriteScreenItem } from './favourite-screen-item.model';

export class FavouriteScreens {
  id?: string;
  favouriteListName?: string;
  screens?: FavouriteScreenItem[];
  constructor(
    id?: string,
    favouriteListName?: string,
    screens?: FavouriteScreenItem[]
  ) {
    this.id = id || null;
    this.favouriteListName = favouriteListName || null;
    this.screens = screens || [];
  }
}
